/* Flash offer popup: asks BEFORE the main product is added, then lets the theme's own add-to-cart run.
   Capture-phase click on the main add button; the theme's delegated jQuery handler runs only when we let the click through. */
(function () {
  'use strict';
  var dlg = document.querySelector('[data-wowe-flash]');
  if (!dlg) return;

  var script = document.currentScript || document.querySelector('script[src*="wowe-flash-offer"]');
  var showDiscount = script && script.getAttribute('data-show-discount') === 'true';
  var offerId = Number(dlg.getAttribute('data-offer-product-id'));
  var addUrl = dlg.getAttribute('data-add-url') || '/cart/add.js';
  var textBusy = dlg.getAttribute('data-text-busy');
  var textYes = dlg.getAttribute('data-text-yes');
  var bypass = false;
  var pendingBtn = null;
  var busy = false;

  var qtyInput = dlg.querySelector('[data-flash-qty-input]');
  var variantField = dlg.querySelector('[data-flash-variant]');
  var priceBox = dlg.querySelector('[data-flash-price]');

  function isMainAddButton(el) {
    var btn = el && el.closest && el.closest('[data-btn-addtocart]');
    if (!btn) return null;
    if (btn.id !== 'product-add-to-cart') return null; // only the main product button, not cards or quick shop
    if (btn.disabled || btn.classList.contains('btn-unavailable') || btn.classList.contains('is-soldout') || btn.classList.contains('is-notify-me')) return null;
    return btn;
  }

  function proceed(btn) {
    bypass = true;
    try { btn.click(); } finally { bypass = false; }
  }

  function closeDialog() {
    if (dlg.open) dlg.close();
  }

  // INP: let the browser paint the closed dialog first, then run the theme's add-to-cart (and the analytics it triggers).
  function afterPaint(fn) {
    requestAnimationFrame(function () { requestAnimationFrame(function () { setTimeout(fn, 0); }); });
  }

  function finish(accepted) {
    var btn = pendingBtn;
    pendingBtn = null;
    closeDialog();
    afterPaint(function () {
      document.dispatchEvent(new CustomEvent('wowe:flash:' + (accepted ? 'accepted' : 'declined'), { detail: { offerProductId: offerId } }));
      if (btn) proceed(btn);
    });
  }

  document.addEventListener('click', function (e) {
    if (bypass) return;
    var btn = isMainAddButton(e.target);
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (pendingBtn || busy) return;
    pendingBtn = btn;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = cart.items.some(function (i) { return i.product_id === offerId; });
        if (inCart) { var b = pendingBtn; pendingBtn = null; proceed(b); return; }
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      })
      .catch(function () { var b = pendingBtn; pendingBtn = null; if (b) proceed(b); });
  }, true);

  function updatePrice() {
    if (!priceBox || !variantField || variantField.tagName !== 'SELECT') return;
    var o = variantField.options[variantField.selectedIndex];
    var html = '';
    if (showDiscount) {
      html = '<s class="wowe-flash__compare">' + o.getAttribute('data-price') + '</s> <span class="wowe-flash__now">' + o.getAttribute('data-sale') + '</span>' + (priceBox.querySelector('.wowe-flash__badge') ? priceBox.querySelector('.wowe-flash__badge').outerHTML : '');
    } else {
      html = '<span class="wowe-flash__now">' + o.getAttribute('data-price') + '</span>';
    }
    priceBox.innerHTML = html;
  }

  dlg.addEventListener('change', function (e) {
    if (e.target === variantField) updatePrice();
    if (e.target === qtyInput) {
      var v = parseInt(qtyInput.value, 10);
      qtyInput.value = isNaN(v) || v < 1 ? 1 : Math.min(v, 99);
    }
  });

  dlg.addEventListener('click', function (e) {
    var q = e.target.closest('[data-flash-qty]');
    if (q) {
      var v = (parseInt(qtyInput.value, 10) || 1) + Number(q.getAttribute('data-flash-qty'));
      qtyInput.value = Math.max(1, Math.min(99, v));
      return;
    }
    if (e.target.closest('[data-flash-decline]')) { if (!busy) finish(false); return; }
    var yes = e.target.closest('[data-flash-accept]');
    if (yes && !busy) {
      busy = true;
      yes.disabled = true;
      yes.textContent = textBusy;
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantField.value), quantity: Number(qtyInput.value) || 1, properties: { _upsell: 'flash' } }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); })
        .catch(function () { /* the main product is still added below */ })
        .then(function () {
          busy = false;
          yes.disabled = false;
          yes.textContent = textYes;
          finish(true);
        });
    }
  });

  // Esc or a click on the backdrop = "no thanks": the main product is still added.
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); if (!busy) finish(false); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg && !busy) finish(false); });
})();
